import * as Cesium from 'cesium';
import type { MapTheme } from '../types';
import { getRuntimeEnv } from './orbitUtils';
import { createNaturalEarthProvider, offline } from '../../../../../../utils/commonFunctions';

export async function buildMapThemeProvider(theme: MapTheme): Promise<Cesium.ImageryProvider> {
  // 1. Offline airgap fallback
  if (offline()) {
    return createNaturalEarthProvider();
  }

  // 2. Mapbox Style Imagery Provider (Online)
  const mapboxToken = process.env.REACT_APP_MAPBOX_TOKEN || getRuntimeEnv('REACT_APP_MAPBOX_TOKEN');
  if (mapboxToken) {
    let styleId = 'dark-v10';
    switch (theme) {
      case 'light':
        styleId = 'light-v10';
        break;
      case 'streets':
      case 'road':
      case 'maptilerStreets' as string:
        styleId = 'streets-v11';
        break;
      case 'satellite':
      case 'aerialLabels':
      case 'maptilerSatellite' as string:
        styleId = 'satellite-v9';
        break;
      case 'outdoors':
      case 'osm' as string:
      case 'maptilerOutdoor' as string:
      case 'maptilerTopo' as string:
        styleId = 'outdoors-v11';
        break;
      case 'dark':
      case 'default':
      default:
        styleId = 'dark-v10';
        break;
    }

    return new Cesium.MapboxStyleImageryProvider({
      styleId,
      accessToken: mapboxToken,
    });
  }

  // 3. Fallback to Cesium's own ImageryProvider when Mapbox token is missing
  switch (theme) {
    case 'satellite':
    case 'aerialLabels':
    case 'maptilerSatellite' as string:
      return Cesium.createWorldImageryAsync({ style: Cesium.IonWorldImageryStyle.AERIAL_WITH_LABELS });
    case 'streets':
    case 'road':
    case 'maptilerStreets' as string:
      return Cesium.createWorldImageryAsync({ style: Cesium.IonWorldImageryStyle.ROAD });
    case 'dark':
    case 'light':
    case 'outdoors':
    case 'default':
    default:
      return Cesium.createWorldImageryAsync({ style: Cesium.IonWorldImageryStyle.AERIAL });
  }
}


